import { FDTextInput } from '@facet-wealth/design';
import { buildFacetDesignFilterFormOverride } from 'Packages/FacetRest/FacetDesignFilterFormOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { AutoCompleteInputLarge } from 'Packages/FacetDesign/Components';

export default buildFacetDesignFilterFormOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  })
  .nameOverride('description', {
    _component: () => FDTextInput,
    _spreadPropNames: ['helperText'],
    _customProps: {
      rows: 8,
      fullWidth: true,
    },
  })
  .nameOverride('disclosure', {
    _component: () => FDTextInput,
    _spreadPropNames: ['helperText'],
    _customProps: {
      rows: 3,
      fullWidth: true,
    },
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => AutoCompleteInputLarge,
    _spreadPropNames: ['helperText'],
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly);
